/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Aaf_Mxf_TitleInputs */

const en_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF/MXF Export`)
};

const fr_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation AAF/MXF`)
};

const de_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF/MXF Export`)
};

const it_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione AAF/MXF`)
};

const ru_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт AAF/MXF`)
};

const es_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación AAF/MXF`)
};

const zh_cn2_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF/MXF 导出`)
};

const ja_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF/MXFエクスポート`)
};

const hi_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एएएफ/एमएक्सएफ निर्यात`)
};

const pt_pt2_subtitle_export_aaf_mxf_title = /** @type {(inputs: Subtitle_Export_Aaf_Mxf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação AAF/MXF`)
};

/**
* | output |
* | --- |
* | "AAF/MXF Export" |
*
* @param {Subtitle_Export_Aaf_Mxf_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_aaf_mxf_title = /** @type {((inputs?: Subtitle_Export_Aaf_Mxf_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Aaf_Mxf_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_aaf_mxf_title(inputs)
	if (locale === "de") return de_subtitle_export_aaf_mxf_title(inputs)
	if (locale === "it") return it_subtitle_export_aaf_mxf_title(inputs)
	if (locale === "ru") return ru_subtitle_export_aaf_mxf_title(inputs)
	if (locale === "es") return es_subtitle_export_aaf_mxf_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_aaf_mxf_title(inputs)
	if (locale === "ja") return ja_subtitle_export_aaf_mxf_title(inputs)
	if (locale === "hi") return hi_subtitle_export_aaf_mxf_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_aaf_mxf_title(inputs)
	return en_subtitle_export_aaf_mxf_title(inputs)
});